import React, { useState } from "react";
import { ChevronRightIcon } from "@heroicons/react/solid";
import {
    ChatIcon,
    CheckIcon,
    UserIcon,
    MailIcon,
} from "@heroicons/react/outline";
import TestimonialCard from "../components/TestimonialCard";

const features = [
    {
        name: "1. Sign up with your email and city",
        description: "",
        icon: UserIcon,
    },
    {
        name: "2. Confirm your email address",
        description: "",
        icon: MailIcon,
    },
    {
        name: "3. That's it!",
        description: "",
        icon: CheckIcon,
    },
];

const DanImage = require("../images/DanielM.jpeg");
const SidImage = require("../images/Sid.jpeg");
const MattImage = require("../images/Matt.jpeg");
const TharunImage = require("../images/Tharun.jpeg");
const AleksaImage = require("../images/Aleksa.jpeg");
const SamuelImage = require("../images/Samuel.jpeg");

const quotes = [
    {
        name: "- Daniel, Machine Learning Engineer @ Microsoft",
        quote: "I’ve been using Ahrain since it came out, and I’d just like to say thank you to Team @ Ahrain! I never knew I needed it before I tried!",

        image: DanImage,
        id: 0,
    },
    {
        name: "- Sid, Software Engineer @ Microsoft",
        quote: "The name is punny but the tool sure is useful! Perfect for those unexpected Seattle showers!",

        image: SidImage,
        id: 1,
    },
    {
        name: "- Matt, Machine Learning Engineer @ FiscalNote",
        quote: "I liked the idea and would like to see an app for it, but as of now, great little tool for living in NYC!",

        image: MattImage,
        id: 2,
    },
    {
        name: "- Tharun, Developer Relations @ Google",
        quote: "I always check email in the morning, so I'm glad Ahrain fits in the flow.",
        image: TharunImage,
        id: 3,
    },
    {
        name: "- Aleksa, Software Engineer at Credit Karma",
        quote: "What inspired me to make Ahrain was me getting fully wet while 5 minutes into walking in sunny weather in Charlotte. Clouds lied! That’s why Ahrain won’t!",
        image: AleksaImage,
        id: 3,
    },
    {
        name: "- Samuel, Software Engineer at J.M. Smucker",
        quote: "I hated weather apps. It’s a waste of time. When Aleksa approached me with the idea of Ahrain, I knew I wanted to be a part of this! I really see thousands of people using this in the future.",
        image: SamuelImage,
        id: 4,
    },
];

const HomeScreen = () => {
    const [currQuote, setCurrQuote] = useState(0);

    return (
        <div className="bg-bgColor pb-4 py-12">
            <main>
                {/* Hero section */}
                <div className="pt-0 overflow-hidden sm:pt-0 lg:relative lg:py-0">
                    <div className="mx-auto max-w-md px-4 sm:max-w-3xl sm:px-6 lg:px-8 lg:max-w-7xl lg:grid lg:grid-cols-2 lg:gap-24">
                        <div>
                            <div className="mt-0">
                                <div>
                                    <a
                                        href="https://github.com/AleksaGavric/Ahrain"
                                        className="inline-flex space-x-4"
                                    >
                                        <span className="rounded px-2.5 py-0 text-xs font-semibold text-mainTheme tracking-wide uppercase">
                                            What's new
                                        </span>
                                        <a
                                            href="https://github.com/AleksaGavric/Ahrain"
                                            className="inline-flex items-center text-sm font-medium text-mainTheme space-x-1"
                                        >
                                            <span>
                                                Just added timezone support
                                            </span>
                                            <ChevronRightIcon
                                                className="h-5 w-5"
                                                aria-hidden="true"
                                            />
                                        </a>
                                    </a>
                                </div>
                                <div className="mt-6 sm:max-w-xl">
                                    <h1 className="text-4xl font-extrabold text-gray-900 tracking-tight sm:text-5xl">
                                        Never get caught in the rain again
                                    </h1>
                                    <p className="mt-6 text-xl text-gray-500">
                                        Ahrain notifies you via email only if it
                                        will rain, for free.
                                    </p>
                                </div>
                                <form
                                    action="https://formsubmit.co/samzi.henderson@gmail.com"
                                    className="mt-12 sm:max-w-lg sm:w-full sm:flex"
                                    method="POST"
                                >
                                    <div className="min-w-0 w-auto">
                                        <label
                                            htmlFor="hero-email"
                                            className="sr-only"
                                        >
                                            Email address
                                        </label>
                                        <input
                                            id="hero-email"
                                            type="email"
                                            className="block w-full border border-gray-300 rounded-md px-5 py-3 text-base text-gray-900 placeholder-gray-500 shadow-sm focus:border-mainTheme focus:ring-mainTheme"
                                            placeholder="Email"
                                            name="email"
                                            required
                                        />
                                    </div>
                                    <div className="min-w-0 sm:ml-3 flex-1">
                                        <label
                                            htmlFor="hero-city"
                                            className="sr-only"
                                        >
                                            City/town
                                        </label>
                                        <input
                                            id="hero-city"
                                            type="city"
                                            name="city"
                                            className="block w-full border border-gray-300 rounded-md px-4 py-3 mt-2 sm:mt-0 text-base text-gray-900 placeholder-gray-500 shadow-sm focus:border-mainTheme focus:ring-mainTheme"
                                            placeholder="City, State"
                                            required
                                        />
                                    </div>
                                    <div className="mt-4 sm:mt-0 sm:ml-3">
                                        <button
                                            type="submit"
                                            className="hover:animate-none animate-bounce block w-full rounded-md border border-transparent px-5 py-3 bg-mainTheme text-base font-medium text-white shadow hover:bg-mainThemeTinted focus:outline-none focus:ring-2 focus:ring-mainTheme focus:ring-offset-2 sm:px-10"
                                        >
                                            Sign up
                                        </button>
                                    </div>
                                    <input
                                        type="hidden"
                                        name="_next"
                                        value="https://ahra.in/thank-you"
                                    />
                                    <input
                                        type="hidden"
                                        name="_subject"
                                        value="New sign up for Ahrain"
                                    />
                                    <input
                                        type="hidden"
                                        name="_cc"
                                        value="team@ahra.in"
                                    />
                                    <input
                                        type="hidden"
                                        name="_cc"
                                        value="aleksagavric1@gmail.com"
                                    />
                                </form>
                            </div>
                        </div>
                    </div>

                    <div className="sm:mx-auto sm:max-w-3xl sm:px-6">
                        <div className="py-6 sm:relative sm:mt-12 sm:py-8 lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2">
                            <div className="hidden sm:block">
                                <div className="absolute inset-y-0 left-1/2 w-screen bg-bgColor rounded-l-3xl lg:left-80 lg:right-0 lg:w-full" />
                                <svg
                                    className="absolute top-8 right-1/2 -mr-3 lg:m-0 lg:left-0"
                                    width={404}
                                    height={392}
                                    fill="none"
                                    viewBox="0 0 404 392"
                                >
                                    <defs>
                                        <pattern
                                            id="837c3e70-6c3a-44e6-8854-cc48c737b659"
                                            x={0}
                                            y={0}
                                            width={20}
                                            height={20}
                                            patternUnits="userSpaceOnUse"
                                        >
                                            <rect
                                                x={0}
                                                y={0}
                                                width={4}
                                                height={4}
                                                className="text-gray-200"
                                                fill="currentColor"
                                            />
                                        </pattern>
                                    </defs>
                                    <rect
                                        width={404}
                                        height={392}
                                        fill="url(#837c3e70-6c3a-44e6-8854-cc48c737b659)"
                                    />
                                </svg>
                            </div>
                            <div className="hidden sm:block sm:relative sm:pl-4 sm:-mr-40 sm:mx-auto sm:max-w-6xl sm:px-0 lg:max-w-none sm:h-full lg:pl-12">
                                <img
                                    className="w-full rounded-md shadow-xl content-center ring-1 ring-black ring-opacity-5 lg:h-auto lg:w-2/3 sm:w-3/4 lg:max-w-none"
                                    src={require("../images/umbrellaInRain2.jpg")}
                                    alt="Umbrella"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                {/* Testimonial/stats section */}
                <div className="relative mt-12">
                    <div className="lg:mx-auto lg:max-w-7xl lg:px-8 lg:grid lg:grid-cols-2 lg:gap-24 lg:items-start">
                        <div className="relative sm:py-16 lg:py-0">
                            <div
                                aria-hidden="true"
                                className="hidden sm:block lg:absolute lg:inset-y-0 lg:right-0 lg:w-screen"
                            >
                                <div className="absolute inset-y-0 right-1/2 w-full bg-bgColor rounded-r-3xl lg:right-72" />
                                <svg
                                    className="absolute top-8 left-1/2 -ml-3 lg:-right-8 lg:left-auto lg:top-12"
                                    width={404}
                                    height={392}
                                    fill="none"
                                    viewBox="0 0 404 392"
                                >
                                    <defs>
                                        <pattern
                                            id="02f20b47-fd69-4224-a62a-4c9de5c763f7"
                                            x={0}
                                            y={0}
                                            width={20}
                                            height={20}
                                            patternUnits="userSpaceOnUse"
                                        >
                                            <rect
                                                x={0}
                                                y={0}
                                                width={4}
                                                height={4}
                                                className="text-gray-200"
                                                fill="currentColor"
                                            />
                                        </pattern>
                                    </defs>
                                    <rect
                                        width={404}
                                        height={392}
                                        fill="url(#02f20b47-fd69-4224-a62a-4c9de5c763f7)"
                                    />
                                </svg>
                            </div>
                            <div className="relative mx-auto max-w-md px-4 sm:max-w-3xl sm:px-6 lg:px-0 lg:max-w-none lg:py-28">
                                <div
                                    id="default-carousel"
                                    className="relative"
                                    data-carousel="slide"
                                >
                                    {/* <!-- Carousel wrapper --> */}
                                    <div className="overflow-hidden relative h-96 rounded-lg ">
                                        <TestimonialCard
                                            quoteItem={quotes[currQuote]}
                                        />
                                    </div>

                                    {/* <!-- Slider indicators --> */}
                                    <div className="flex absolute bottom-5 left-1/2 z-30 space-x-3 -translate-x-1/2">
                                        <button
                                            type="button"
                                            className="w-3 h-3 rounded-full"
                                            aria-current="false"
                                            aria-label="Slide 1"
                                            data-carousel-slide-to="0"
                                        ></button>
                                        <button
                                            type="button"
                                            className="w-3 h-3 rounded-full"
                                            aria-current="false"
                                            aria-label="Slide 2"
                                            data-carousel-slide-to="1"
                                        ></button>
                                        <button
                                            type="button"
                                            className="w-3 h-3 rounded-full"
                                            aria-current="false"
                                            aria-label="Slide 3"
                                            data-carousel-slide-to="2"
                                        ></button>
                                    </div>
                                    {/* <!-- Slider controls --> */}
                                    <button
                                        onClick={() => {
                                            if (currQuote === 0)
                                                setCurrQuote(quotes.length - 1);
                                            else setCurrQuote(currQuote - 1);
                                        }}
                                        type="button"
                                        className="flex absolute bottom-0 left-0 z-30 justify-center items-center px-4 h-full cursor-pointer group focus:outline-none"
                                        data-carousel-prev
                                    >
                                        <span className="inline-flex justify-center items-center w-8 h-8 rounded-full sm:w-10 sm:h-10 bg-white/30 dark:bg-gray-800/30 group-hover:bg-white/50 dark:group-hover:bg-gray-800/60 group-focus:ring-4 group-focus:ring-white dark:group-focus:ring-gray-800/70 group-focus:outline-none">
                                            <svg
                                                className="w-5 h-5 text-white sm:w-6 sm:h-6 dark:text-gray-800"
                                                fill="none"
                                                stroke="currentColor"
                                                viewBox="0 0 24 24"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                    stroke-width="2"
                                                    d="M15 19l-7-7 7-7"
                                                ></path>
                                            </svg>
                                            <span className="hidden">
                                                Previous
                                            </span>
                                        </span>
                                    </button>
                                    <button
                                        onClick={() => {
                                            if (currQuote === quotes.length - 1)
                                                setCurrQuote(0);
                                            else setCurrQuote(currQuote + 1);
                                        }}
                                        type="button"
                                        className="flex absolute bottom-0 right-0 z-30 justify-center items-center px-4 h-full cursor-pointer group focus:outline-none"
                                        data-carousel-next
                                    >
                                        <span className="inline-flex justify-center items-center w-8 h-8 rounded-full sm:w-10 sm:h-10 bg-white/30 dark:bg-gray-800/30 group-hover:bg-white/50 dark:group-hover:bg-gray-800/60 group-focus:ring-4 group-focus:ring-white dark:group-focus:ring-gray-800/70 group-focus:outline-none">
                                            <svg
                                                className="w-5 h-5 text-white sm:w-6 sm:h-6 dark:text-gray-800"
                                                fill="none"
                                                stroke="currentColor"
                                                viewBox="0 0 24 24"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                    stroke-width="2"
                                                    d="M9 5l7 7-7 7"
                                                ></path>
                                            </svg>
                                            <span className="hidden">Next</span>
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className="relative mx-auto max-w-md px-4 sm:max-w-3xl sm:px-6 lg:px-0 mt-8">
                            {/* Content area */}
                            <div className="pt-12 sm:pt-16 lg:pt-20">
                                <h2 className="text-3xl text-gray-900 font-extrabold tracking-tight sm:text-4xl">
                                    Stay one step ahead of the weather
                                </h2>
                                <div className="mt-6 text-gray-500 space-y-6">
                                    <p className="text-lg">
                                        Rain sucks. Getting caught in the rain
                                        sucks even more! What doesn't suck then?
                                        Ahrain!
                                    </p>
                                    <p className="text-lg leading-7">
                                        Ahrain is here to alert to you the
                                        morning of the day it will rain, ONLY if
                                        it will rain. Here's why it's awesome:
                                    </p>
                                    <ul className="text-lg leading-7 list-disc ml-4 mb-4 pb-4">
                                        <li>It's free!</li>
                                        <li>
                                            Runs an automated rain check every
                                            morning at 5am
                                        </li>
                                        <li>
                                            Delivers an email only if there will
                                            be rain on that day
                                        </li>
                                        <li>
                                            Fits into your morning email digest
                                        </li>
                                        <li>
                                            Microptimizes your day by saving you
                                            time spent doing the repetitive task
                                            of checking the weather every day
                                        </li>
                                        <li>
                                            <a
                                                href="https://github.com/AleksaGavric/Ahrain"
                                                className="text-lg text-mainTheme"
                                            >
                                                Open source
                                            </a>{" "}
                                            and built with Python and AWS
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* How it works section */}
                <div className="relative bg-bgColor py-8 sm:py-8 lg:py-8">
                    <div className="mx-auto max-w-md px-4 text-center sm:max-w-3xl sm:px-6 lg:px-8 lg:max-w-7xl">
                        <h2 className="text-base font-semibold tracking-wider text-cyan-600 uppercase"></h2>
                        <p className="mt-2 text-3xl font-extrabold text-gray-900 tracking-tight sm:text-4xl">
                            How to get started
                        </p>
                        <p className="mt-5 max-w-prose mx-auto text-xl text-gray-500">
                            Follow these steps to start using Ahrain
                        </p>
                        <div className="mt-12">
                            <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
                                {features.map((feature) => (
                                    <div key={feature.name} className="pt-6">
                                        <div className="flow-root bg-mainTheme rounded-lg px-6 pb-8">
                                            <div className="-mt-6">
                                                <div>
                                                    <span className="inline-flex items-center justify-center p-3 bg-gradient-to-r from-mainTheme to-secondaryTheme rounded-md shadow-lg">
                                                        <feature.icon
                                                            className="h-6 w-6 text-white"
                                                            aria-hidden="true"
                                                        />
                                                    </span>
                                                </div>
                                                <h3 className="mt-8 text-lg font-medium text-white tracking-tight">
                                                    {feature.name}
                                                </h3>
                                                <p className="mt-5 text-base text-white">
                                                    {feature.description}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                {/* How it works section */}
                <div className="relative bg-bgColor py-8 sm:py-8 lg:py-8">
                    <div className="mx-auto max-w-md px-4 text-center sm:max-w-3xl sm:px-6 lg:px-8 lg:max-w-7xl">
                        <h2 className="text-base font-semibold tracking-wider text-cyan-600 uppercase"></h2>
                        <p className="mt-2 text-3xl font-extrabold text-gray-900 tracking-tight sm:text-4xl">
                            How it looks
                        </p>
                        <p className="mt-5 max-w-prose mx-auto text-xl text-gray-500">
                            Ahrain comes as a custom HTML email for easy reading
                            and night mode
                        </p>
                        <div className="mt-12">
                            <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
                                {/* {features.map((feature) => (
                                    <div key={feature.name} className="pt-6">
                                        <div className="flow-root bg-mainTheme rounded-lg px-6 pb-8">
                                            <div className="-mt-6">
                                                <div>
                                                    <span className="inline-flex items-center justify-center p-3 bg-gradient-to-r from-mainTheme to-secondaryTheme rounded-md shadow-lg">
                                                        <feature.icon
                                                            className="h-6 w-6 text-white"
                                                            aria-hidden="true"
                                                        />
                                                    </span>
                                                </div>
                                                <h3 className="mt-8 text-lg font-medium text-white tracking-tight">
                                                    {feature.name}
                                                </h3>
                                                <p className="mt-5 text-base text-white">
                                                    {feature.description}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                ))} */}

                                <div className="pt-60">
                                    <div className="flow-root bg-mainTheme rounded-lg px-6 pb-8">
                                        <div className="-mt-6">
                                            <div>
                                                <span className="hover:scale-150 inline-flex items-center justify-center p-3 bg-gradient-to-r from-mainTheme to-secondaryTheme rounded-md shadow-lg">
                                                    <img
                                                        src={require("../images/gmail.png")}
                                                        alt="Logo"
                                                    ></img>
                                                </span>
                                            </div>
                                            <h3 className="mt-8 text-lg font-medium text-white tracking-tight">
                                                Browser
                                            </h3>
                                        </div>
                                    </div>
                                </div>

                                <div className="pt-56">
                                    <div className="flow-root bg-mainTheme rounded-lg px-6 pb-8">
                                        <div className="-mt-6">
                                            <div>
                                                <span className="hover:scale-150 inline-flex items-center justify-center p-3 bg-gradient-to-r from-mainTheme to-secondaryTheme rounded-md shadow-lg">
                                                    <img
                                                        src={require("../images/desktop.png")}
                                                        alt="Logo"
                                                    ></img>
                                                </span>
                                            </div>
                                            <h3 className="mt-8 text-lg font-medium text-white tracking-tight">
                                                Desktop
                                            </h3>
                                        </div>
                                    </div>
                                </div>

                                <div className="pt-6">
                                    <div className="flow-root bg-mainTheme rounded-lg px-6 pb-8">
                                        <div className="-mt-6">
                                            <div>
                                                <span className="hover:scale-110 inline-flex items-center justify-center p-3 bg-gradient-to-r from-mainTheme to-secondaryTheme rounded-md shadow-lg">
                                                    <img
                                                        src={require("../images/phone.jpg")}
                                                        alt="Logo"
                                                    ></img>
                                                </span>
                                            </div>
                                            <h3 className="mt-8 text-lg font-medium text-white tracking-tight">
                                                Phone
                                            </h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* CTA section */}
                <div className="relative mt-4 sm:mt-4 sm:py-16 bg-bgColor">
                    <div aria-hidden="true" className="hidden sm:block">
                        <div className="absolute inset-y-0 left-0 w-1/2 bg-bgColor rounded-r-3xl" />
                        <svg
                            className="absolute top-8 left-1/2 -ml-3"
                            width={404}
                            height={392}
                            fill="none"
                            viewBox="0 0 404 392"
                        >
                            <defs>
                                <pattern
                                    id="8228f071-bcee-4ec8-905a-2a059a2cc4fb"
                                    x={0}
                                    y={0}
                                    width={20}
                                    height={20}
                                    patternUnits="userSpaceOnUse"
                                >
                                    <rect
                                        x={0}
                                        y={0}
                                        width={4}
                                        height={4}
                                        className="text-gray-200"
                                        fill="currentColor"
                                    />
                                </pattern>
                            </defs>
                            <rect
                                width={404}
                                height={392}
                                fill="url(#8228f071-bcee-4ec8-905a-2a059a2cc4fb)"
                            />
                        </svg>
                    </div>
                    <div className="mx-auto max-w-md px-4 sm:max-w-3xl sm:px-6 lg:max-w-7xl lg:px-8">
                        <div className="relative rounded-2xl px-6 py-10 bg-mainTheme overflow-hidden shadow-xl sm:px-12 sm:py-20">
                            <div
                                aria-hidden="true"
                                className="absolute inset-0 -mt-72 sm:-mt-32 md:mt-0"
                            >
                                <svg
                                    className="absolute inset-0 h-full w-full"
                                    preserveAspectRatio="xMidYMid slice"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 1463 360"
                                >
                                    <path
                                        className="text-mainTheme text-opacity-40"
                                        fill="currentColor"
                                        d="M-82.673 72l1761.849 472.086-134.327 501.315-1761.85-472.086z"
                                    />
                                    <path
                                        className="text-mainThemeTinted text-opacity-40"
                                        fill="currentColor"
                                        d="M-217.088 544.086L1544.761 72l134.327 501.316-1761.849 472.086z"
                                    />
                                </svg>
                            </div>
                            <div className="relative">
                                <div className="sm:text-center">
                                    <h2 className="text-3xl font-extrabold text-white text-center tracking-tight sm:text-4xl">
                                        Say goodbye to{" "}
                                        <p className="font-bold animate-ping">
                                            "Ahh Rain!"
                                        </p>{" "}
                                        moments
                                    </h2>
                                    <p className="mt-6 mx-auto max-w-2xl text-lg text-rose-100">
                                        Enter your email, city and state below
                                        to sign up. Unsubscribe at any time!
                                    </p>
                                </div>
                                <form
                                    action="https://formsubmit.co/samzi.henderson@gmail.com"
                                    className="mt-12 sm:mx-auto sm:max-w-lg sm:flex"
                                    method="POST"
                                >
                                    <div className="min-w-0 flex">
                                        <label
                                            htmlFor="cta-email"
                                            className="sr-only"
                                        >
                                            Email address
                                        </label>
                                        <input
                                            id="cta-email"
                                            type="email"
                                            className="block w-full border border-transparent rounded-md px-5 py-3 text-base text-gray-900 placeholder-gray-500 shadow-sm focus:outline-none focus:border-transparent focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-mainTheme"
                                            placeholder="Email"
                                            required
                                            name="email"
                                        />
                                    </div>
                                    <div className="min-w-0 flex-1 sm:ml-3 mt-2 sm:mt-0">
                                        <label
                                            htmlFor="cta-city"
                                            className="sr-only"
                                        >
                                            City or town
                                        </label>
                                        <input
                                            id="cta-city"
                                            type="city"
                                            className="block w-full border border-transparent rounded-md px-4 py-3 text-base text-gray-900 placeholder-gray-500 shadow-sm focus:outline-none focus:border-transparent focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-mainTheme"
                                            placeholder="City, State"
                                            required
                                            name="city"
                                        />
                                    </div>
                                    <div className="mt-4 sm:mt-0 sm:ml-3">
                                        <button
                                            type="submit"
                                            className="block w-full rounded-md border border-transparent px-5 py-3 bg-gray-900 text-base font-medium text-white shadow hover:bg-black focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-mainTheme sm:px-10"
                                        >
                                            Sign up
                                        </button>
                                    </div>
                                    <input
                                        type="hidden"
                                        name="_next"
                                        value="https://ahra.in/thank-you"
                                    />
                                    <input
                                        type="hidden"
                                        name="_subject"
                                        value="New sign up for Ahrain"
                                    />
                                    <input
                                        type="hidden"
                                        name="_cc"
                                        value="team@ahra.in"
                                    />
                                    <input
                                        type="hidden"
                                        name="_cc"
                                        value="aleksagavric1@gmail.com"
                                    />
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default HomeScreen;
